import { makeStyles, TextField } from '@material-ui/core';
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as shoppingCartActions from '~/store/legacy/actions/shoppingCartActions';
import * as shoppingCartSelectors from '~/store/legacy/selector/shoppingCartSelectors.js';

export default NumericTipsInput;

const useStyles = makeStyles({
  tipInput: {
    borderLeft: '1px solid #E1E1E1',
    width: '31%',
    padding: '11px 15px',
  },
});

function NumericTipsInput() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [displayValue, setDisplayValue] = useState('');
  const uiTips = useSelector(shoppingCartSelectors.uiTips);
  useEffect(() => {
    if (uiTips.inputType !== 'freeCurrency') {
      setDisplayValue('');
    }
  }, [uiTips.inputType]);

  let decimalsNumberCheck = useCallback((newValue) => {
    newValue = newValue.replace(/[^\d.]/g, ''); // 清除“数字”和“.”以外的字符
    newValue = newValue.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
    newValue = newValue.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    newValue = newValue.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数

    return newValue;
  }, []);

  function onTipInput(e) {
    let tipValue = e?.target?.value || '';
    tipValue = decimalsNumberCheck(tipValue);
    if (tipValue.indexOf('.') === 0) {
      // 小数点在第一位 首位添加0
      tipValue = '0' + tipValue;
    }
    setDisplayValue(tipValue);
    dispatch(
      shoppingCartActions.onTipsInputChangeAction({
        inputType: 'freeCurrency',
        value: tipValue,
      })
    );
  }

  return (
    <TextField
      className={classes.tipInput}
      placeholder='Other'
      type='number'
      InputProps={{ inputProps: { min: 0, inputMode: 'decimal', step: '0.1' } }}
      onChange={onTipInput}
      value={displayValue}
    />
  );
}
